import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'switchEnum',
  standalone: true,
})
export class SwitchEnumPipe implements PipeTransform {
  public transform<T extends string | number>(value: T | null | undefined, options: Record<string, string>): string {
    if (value == null) {
      return '';
    }
    if (!options || !Object.keys(options)?.length) {
      return String(value);
    }
    return options[value as keyof typeof options] ?? String(value);
  }
}
